import { render, staticRenderFns } from "./OrderInput.vue?vue&type=template&id=10cda55a&scoped=true&"
import script from "./OrderInput.vue?vue&type=script&lang=js&"
export * from "./OrderInput.vue?vue&type=script&lang=js&"
import style0 from "./OrderInput.vue?vue&type=style&index=0&id=10cda55a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cda55a",
  null
  
)

export default component.exports